define(
    'utils/rivets-formatters',[
        'utils/price-format',
        'settings',
        'rivets',
        'moment'
    ],


    /*
        OBS! Since rivets 0.7, all arguments to formatters are
        parsed as keypaths, unless if they are sent as strings.

        So be sure to use 'myLiteralValue' to send a string, but
        Numbers can still be sent unquoated.

        i.e. in compare, if you are specifying an operator to
        use, send it as a string '!=', otherwise it will be
        undefined.
    */

    function (priceFormat, settings, rivets, moment) {

        rivets.formatters.getFirstImageSrc = function (value) {
            if (!value || !value[0] || !value[0].images[0]) return;
            return value[0].images[0].src;
        };

        rivets.formatters.count = function (value) {
            if (value === undefined || value === null) {
                return;
            }

            return value.length;
        };

        rivets.formatters.append = function (lvalue, rvalue) {
            var result = lvalue + rvalue;
            return result;
        };

        rivets.formatters.capitalize = function (value) {
            if (value === undefined || value === null) {
                return;
            }

            return value.substring(0, 1).toUpperCase() + value.slice(1);
        };

        rivets.formatters.capitalizeAll = function (value) {
            if (value === undefined || value === null) {
                return;
            }

            return value.toUpperCase();
        };

        /*
        rivets.formatters.customerDisplayName = function (value) {
            return (value.Name && $.trim(value.Name)) ? value.Name : value.Email;
        };
        
        rivets.formatters.fallback = function(value, defaultval) {
            return value || defaultval;
        };        
        
        rivets.formatters.hidecountrydropdown = function (o, country) {
            if (country == 1 && typeof o === "undefined" || country >= 1 && typeof o !== "undefined") 
                return true;   
        };        

        rivets.formatters.ordinaryordiscount = function (value) {
            // Get the ordinary or dicount price
            var v = (value.discount) ? value.discount : value.ordinary;
            if (typeof v !== "number") {
                return;
            }
            return v.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ');
        };
        */

        /*
        rivets.formatters.money = function (value, discount) {

            if (typeof value !== "number") {
                return;
            }

            return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ');
        };
        */

        rivets.formatters.priceTotal = function (list, property, placed) {
            var priceObj = { total: 0 };

            if (!property) throw new Error('PriceTotal property must be set');
            if (list.configurations) list = [list];
            if (list.price) list = [{ configurations: [list] }];

            $.each(list, function () {
                $.each(this.configurations, function () {
                    if (this.price) {
                        var priceInt;

                        if (placed && this.price.hasOwnProperty('placedPrice') && this.price.placedPrice !== null) {
                            priceInt = this.price.placedPrice;
                        } else if (this.price.hasOwnProperty(property) && this.price[property] !== null) {
                            priceInt = this.price[property];
                        }
                        else if ((this.price.hasOwnProperty('discount') && this.price.discount !== null) || (this.price.hasOwnProperty('ordinary') && this.price.ordinary !== null)) {
                            priceInt = (this.price.discount !== null) ? this.price.discount : this.price.ordinary;
                        } else {
                            return false;
                        }

                        priceObj.total += (priceInt * (this.quantity || 1));
                    }
                    if (!priceObj.currency) priceObj.currency = this.price.currency;
                });
            });

            return rivets.formatters.priceFormat(priceObj, 'total');
        };

        rivets.formatters.priceFormat = function (value, property, placed) {
            return priceFormat(value, property, placed);
        };

        // DEPRECATED
        // rivets.formatters.retailPriceFormat = function (value) {    
        //     var retail = (value.retail) ? priceFormat(value, 'retail', false) : '';
        //     var customer = (value.ordinary || value.discount) ? priceFormat(value) : '';

        //     var priceString =   '' + 
        //                         customer + 
        //                         ((customer && retail) ? ' / ' : '') +
        //                         retail;

        //     return priceString;
        // };

        rivets.formatters.dateFormat = function (value, format) {
            return moment(parseInt(value, 10)).format('YYYY-MM-DD');
        };

        // Example rv-if="array.length | compare 0 '!='"
        rivets.formatters.compare = function (lvalue, rvalue, operator) {

            if (arguments.length < 2)
                throw new Error("rivets formatter 'compare' needs 2 parameters");

            operator = operator || "==";

            var operators = {
                '==': function (l, r) {
                    return l == r;
                },
                '===': function (l, r) {
                    return l === r;
                },
                '!=': function (l, r) {
                    return l != r;
                },
                '<': function (l, r) {
                    return l < r;
                },
                '>': function (l, r) {
                    return l > r;
                },
                '<=': function (l, r) {
                    return l <= r;
                },
                '>=': function (l, r) {
                    return l >= r;
                },
                'typeof': function (l, r) {
                    return typeof l == r;
                }
            };

            if (!operators[operator])
                throw new Error("rivets formatter 'compare' doesn't know the operator " + operator);

            // validate length if lvalue is array and rvalue is number.
            if (typeof lvalue === 'object' && lvalue.hasOwnProperty('length') && String(parseInt(rvalue, 10)) === String(rvalue)) {
                lvalue = lvalue.length;
            }

            var result = false;
            if (typeof rvalue === "string") {
                var valuesToCompareArray = rvalue.split(",");

                $.each(valuesToCompareArray, function (i, value) {
                    if (operators[operator](lvalue, value)) {
                        result = true;
                    }
                });
            } else {
                result = operators[operator](lvalue, rvalue);
            }

            return result;
        };

        /**
         * Checks if value is zero rounded to n decimals after decimal point.
         *
         * @param  {any}  value
         * @param  {number}  n  The number of digits after the decimal point.
         * @return {Boolean}
         */
        rivets.formatters.isRoundedZero = function (value, n) {

            value = parseFloat(value);
            if (isNaN(value)) {
                return true;
            }

            /* jshint ignore:start */
            if (value.toFixed(2) == 0) {
                return true;
            }
            /* jshint ignore:end */

            return false;
        };

        /**
         * Checks if value is a valid stock. I.e not false and not isNaN.
         *
         * @param  {any}  value
         * @return {Boolean}
         */
        rivets.formatters.isValidStock = function (value) {
            return value !== false && !isNaN(value);
        };
    }
);
